import type {
  CategoryDTO,
  CreateCategoryDTO,
  UpdateCategoryDTO,
} from "@/modules/form-center/domain/contracts/categories";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import type { CategoriesListResult } from "@/modules/form-center/domain/types/categories";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

const baseUrl = `${config.apiUrl}/forms/categories`;

export const categoriesApi = {
  async list(query: Partial<OffsetPageQueryDTO> = {}): Promise<CategoriesListResult> {
    const url = new URL(baseUrl);
    if (query.limit) url.searchParams.set("limit", String(query.limit));
    if (query.offset) url.searchParams.set("offset", String(query.offset));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<CategoriesListResult>(url.toString());
  },

  async get(id: string): Promise<CategoryDTO> {
    return fetcher.get(`${baseUrl}/${id}`);
  },

  async create(input: CreateCategoryDTO): Promise<CategoryDTO> {
    return fetcher.post(`${baseUrl}`, input);
  },

  async update(id: string, input: UpdateCategoryDTO): Promise<CategoryDTO> {
    return fetcher.patch(`${baseUrl}/${id}`, input);
  },

  async remove(id: string): Promise<void> {
    return fetcher.delete(`${baseUrl}/${id}`);
  },
};
